<template>
  <div>
    <template v-if="this.data != null"> Prvotní konfigurace stanice </template>
    <template v-else>
      <LoadingData />
    </template>
  </div>
</template>

<script>
import LoadingData from "../LoadingData.vue";

export default {
  name: "StationStationConfigService",
  props: {},
  components: {
    LoadingData,
  },
  data() {
    return {};
  },
};
</script>

<style scoped></style>
